import React from 'react';
import { useErrorBoundary } from '@wix/yoshi-flow-editor';

export const withErrorState = (
  Component: React.ComponentType,
  ErrorState: React.ComponentType<any>,
): React.ComponentType => {
  return props => {
    const { error, errorId } = useErrorBoundary();

    if (error) {
      return <ErrorState workerError={{ error, errorId }} {...props} />;
    }

    return <Component {...props} />;
  };
};
